import { ColDef, ColGroupDef, GridOptions, ToolPanelDef } from '@ag-grid-community/core'

// Alpha-sort the items within each group of a columns tool-panel layout, by their display name, so the
// column selector lists each group's items in order. Group order itself is left unchanged.
export function sortColumnGroupsByName<T>(
  layout: (ColDef<T> | ColGroupDef<T>)[],
): (ColDef<T> | ColGroupDef<T>)[] {
  return layout.map((group) => {
    if (!('children' in group)) return group
    // Numeric collation so key-rate tenors sort as a ladder (1M, 1Y, 2Y, … 30Y) rather than
    // lexicographically (10Y, 1M, 1Y, 20Y, …); also case- and locale-stable.
    const children = [...group.children].sort((a, b) =>
      (a.headerName ?? '').localeCompare(b.headerName ?? '', undefined, { numeric: true, sensitivity: 'base' }),
    )
    return { ...group, children }
  })
}

export const columnsSideBarPanelDef: ToolPanelDef = {
  id: 'columns',
  labelDefault: 'Columns',
  labelKey: 'columns',
  iconKey: 'columns',
  toolPanel: 'agColumnsToolPanel',
  toolPanelParams: {
    suppressRowGroups: true,
    suppressValues: true,
    suppressPivots: true,
    suppressPivotMode: true,
    suppressSideButtons: true,
    suppressColumnFilter: false,
    suppressColumnSelectAll: false,
    suppressColumnExpandAll: false,
  },
}

export const filtersSideBarPanelDef: ToolPanelDef = {
  id: 'filters',
  labelDefault: 'Filters',
  labelKey: 'filters',
  iconKey: 'filter',
  toolPanel: 'agFiltersToolPanel',
  toolPanelParams: {
    suppressExpandAll: true,
    suppressFilterSearch: true,
  },
}

export const themeClassName = 'ag-theme-quartz'

/** Grid theme classes: quartz (light/dark) + the shared ag-theme-cwan layer. Pair with useDarkModeCheck(). */
export function getGridThemeClass(isDarkMode = false): string {
  return `${isDarkMode ? 'ag-theme-quartz-dark' : 'ag-theme-quartz'} ag-theme-cwan`
}

export const legacyDefaultGridOptions: GridOptions = {
  animateRows: true,
  pivotMode: false,
  defaultColDef: { resizable: false, flex: 1 },

  suppressHorizontalScroll: true,
  suppressMovableColumns: false,
  suppressRowClickSelection: true,
}

export const sideBarDefaultConfig = {
  toolPanels: [columnsSideBarPanelDef, filtersSideBarPanelDef],
  hiddenByDefault: false,
}
